module.exports = __webpack_public_path__ + "static/media/andrii_saranenko.f1df2284.jpg";